import React from 'react';
import { MARGIN_BOTTOM } from '../../../common/componentUtils';
import { PDFViewerPage } from '../PDFViewerPage';

interface PageRendererProps {
	index: number;
	data: any;
	style: any;
}

export const PDFViewerPageRenderer = (props: PageRendererProps) => {
	const { index, data, style } = props;
	const pageNumber = index + 1;
	const {
		pageWidth,
		hasDifferentPageSizes,
		overlay,
		pageIndexRatio,
		onPageClick,
		selectedPage,
		setSelectedPage,
		highlightClickedPage,
		pageStyle,
		renderTextLayer,
		renderAnnotationLayer,
		pdfLoader,
	} = data;

	const scale = pageIndexRatio.get(pageNumber);
	const pageHeight = pageIndexRatio.get(pageNumber) * pageWidth;

	const pageMetadata = {
		pageNumber,
		pageWidth,
		pageHeight,
		scale,
	};

	const onPageClickCallback = () => {
		onPageClick!(pageNumber);
		setSelectedPage && setSelectedPage(pageNumber);
	};

	return (
		<div style={{ ...style }} id={`page-${pageNumber}`} tabIndex={0}>
			<div
				style={{
					position: 'relative',
					height: hasDifferentPageSizes ? `calc(100% - ${MARGIN_BOTTOM}px)` : '',
				}}
			>
				{overlay && overlay(pageMetadata)}
				<PDFViewerPage
					pageNumber={pageNumber}
					width={pageWidth}
					onClick={onPageClickCallback}
					pageStyle={pageStyle}
					renderTextLayer={renderTextLayer}
					renderAnnotationLayer={renderAnnotationLayer}
					isPageSelected={highlightClickedPage && selectedPage === pageNumber}
					loader={pdfLoader}
				/>
			</div>
		</div>
	);
};
